<mat-toolbar color="primary">
  <div class="buttonMenu" (click)="toggleDrawer()" aria-label="Menú lateral">
    <mat-icon>menu</mat-icon>
  </div>
  <img
    src="assets/logotipo_workenfactor_blanco.png"
    alt="Logo"
    class="app-logo ms-3"
    height="32"
  />
  <span class="ms-3">{{titleFromMenu}}</span>
  <span class="spacer"></span>
  <app-menu-user ></app-menu-user>
</mat-toolbar>